var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"c-section-outstream"},[(_vm.isActive)?_c('div',{staticClass:"c-section-outstream__content"},[(_vm.isFreewheelAdSystem)?_c('ui-ad-intext-roll',{attrs:{"params":_vm.getFWAdParams()}}):(_vm.spaceId && _vm.isHQSmartAd)?_c('v-ad-banner',{attrs:{"ad-system":_vm.adSystem,"space-id":_vm.spaceId}}):_vm._e()],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }